import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'LOGIN_ACCOUNT_RECOVERY_SUCCESS_TITLE',
    defaultMessage: 'Geschafft!',
  },
  description1: {
    id: 'LOGIN_ACCOUNT_RECOVERY_SUCCESS_PARAGRAPH_1',
    defaultMessage:
      'Vielen Dank – wir prüfen nun Ihre Angaben und melden uns innerhalb von 2 Werktagen an Ihrer neuen Adresse ({username}).',
  },
  description2: {
    id: 'LOGIN_ACCOUNT_RECOVERY_SUCCESS_PARAGRAPH_2',
    defaultMessage:
      'Hinweis: Sollten Sie Ihren Account zur Zeit deaktiviert haben, wird dieser automatisch und umgehend wieder aktiviert.',
  },
  description3: {
    id: 'LOGIN_ACCOUNT_RECOVERY_SUCCESS_PARAGRAPH_3',
    defaultMessage: 'Sie können diese Seite nun schließen.',
  },
  furtherQuestionsText: {
    id: 'LOGIN_ACCOUNT_RECOVERY_SUCCESS_FURTHER_QUESTIONS',
    defaultMessage: 'Fragen? Schreiben Sie uns gern.',
  },
});
